import React from "react";
import styles from "./EmployeeTable.module.css";
import { useField } from "formik";
import { TextInput as MiloInput } from "@justworkshr/milo-form";
import { SystemIcon } from "@justworkshr/milo-components";
interface ITextInputProps {
  name: string;
  placeholder?: string;
  type?: string;
}

const TableTextInput = ({ ...props }: ITextInputProps): JSX.Element => {
  const { name, placeholder, type } = props;
  const [field, meta] = useField(props);

  return (
    <div>
      <MiloInput
        className={styles.textInput}
        data-testid={name}
        id={name}
        placeholder={placeholder}
        type={type}
        {...field}
      />
      {meta.touched && meta.error && (
        <span className={styles.fieldError}>
          <SystemIcon iconName="error" color="error" size="small" />
          {meta.error}
        </span>
      )}
    </div>
  );
};

export default TableTextInput;
